// Runs `fn` every `ms` while the tab is visible, and once right away when it
// becomes visible again. Returns a function that stops it.
export function pollWhileVisible(fn, ms) {
    const isVisible = () => document.visibilityState === 'visible';

    const interval = setInterval(() => {
        if (isVisible()) fn();
    }, ms);

    const onVisibilityChange = () => {
        if (isVisible()) fn();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
        clearInterval(interval);
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
}
